module.exports = __webpack_public_path__ + "static/media/labaton-abdata-logo-cropped.f8f4a709.png";